<template>
  <v-icon
    size="medium"
    :color="getStockStatusColor(stockStatus)"
    :icon="mdiCircle"
    :aria-label="$t('stockStatusDescription', [$t('stockStatus.' + stockStatus)])"
  />
</template>

<script setup lang="ts">
import { SimpleStockStatus } from '@/generatedTypes'
import { getStockStatusColor } from '@/modules/product/helpers'
import { mdiCircle } from '@mdi/js'
import { PropType } from 'vue'

defineProps({
  stockStatus: {
    type: String as PropType<SimpleStockStatus>,
    default: undefined
  }
})
</script>
